/* src/app/components/article-option-group-flavor/article-option-group-flavor.component.scss */
/*# sourceMappingURL=article-option-group-flavor.component.css.map */
